export function ensureRecipientMention(content, agentId) {
    const mention = `<@${agentId}>`;
    return content.includes(mention) ? content : `${content}\n\n${mention}`;
}
//# sourceMappingURL=recipient-message.js.map